'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utils = require('../utils');

var _translationUtils = require('@wix/photography-client-lib/dist/src/utils/translationUtils');

var _translationUtils2 = _interopRequireDefault(_translationUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullscreenCheckoutLink = function (_React$Component) {
  (0, _inherits3.default)(FullscreenCheckoutLink, _React$Component);

  function FullscreenCheckoutLink() {
    (0, _classCallCheck3.default)(this, FullscreenCheckoutLink);
    return (0, _possibleConstructorReturn3.default)(this, (FullscreenCheckoutLink.__proto__ || (0, _getPrototypeOf2.default)(FullscreenCheckoutLink)).apply(this, arguments));
  }

  (0, _createClass3.default)(FullscreenCheckoutLink, [{
    key: 'getLinkText',
    value: function getLinkText(count) {
      return _translationUtils2.default.getByKey('Gallery_ArtStore_UOU_Continue_Checkout_Label') + (' (' + count + ')');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _onClick = _props.onClick,
          cartItemsCount = _props.cartItemsCount;

      return cartItemsCount ? _react2.default.createElement(
        'button',
        {
          className: 'pro-fullscreen-checkout-link',
          onClick: function onClick() {
            return _onClick();
          },
          tabIndex: _utils.utils.getTabIndex('fullscreenCheckout'),
          'aria-label': this.getLinkText(cartItemsCount)
        },
        this.getLinkText(cartItemsCount)
      ) : null;
    }
  }]);
  return FullscreenCheckoutLink;
}(_react2.default.Component);

exports.default = FullscreenCheckoutLink;